export const categories = [
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line' },
  { slug: 'action', name: '动作', icon: 'ri-flashlight-line' },
  { slug: 'drama', name: '剧情', icon: 'ri-emotion-line' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-happy-line' },
  { slug: 'thriller', name: '悬疑', icon: 'ri-search-eye-line' },
  { slug: 'daily', name: '日常', icon: 'ri-sun-line' },
  { slug: 'historical', name: '古风', icon: 'ri-ancient-gate-line' },
];

export const comics = [
  {
    slug: 'goddess-of-destiny',
    title: '命运女神',
    category: 'romance',
    author: '金智慧',
    status: '连载中',
    rating: 9.2,
    views: 1280000,
    description: '平凡的女高中生林晓雨，在某天突然被神秘力量卷入异世界。她发现自己竟然是传说中的命运女神转世，肩负着拯救两个世界的使命。在充满魔法与冒险的异世界中，她遇到了冷酷的骑士团长、温柔的精灵王子，展开了一段跨越时空的奇幻恋爱故事。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20style%20romantic%20fantasy%20cover%20art%20featuring%20a%20beautiful%20goddess%20with%20flowing%20hair%20in%20a%20magical%20world%2C%20soft%20warm%20lighting%20with%20peach%20and%20gold%20tones%2C%20clean%20simple%20gradient%20background%2C%20elegant%20artistic%20illustration%20style%2C%20dreamy%20atmosphere%2C%20no%20text%20overlay%2C%20high%20quality%20digital%20art&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    thumbImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20style%20romantic%20fantasy%20thumbnail%20cover%20art%2C%20beautiful%20goddess%20portrait%2C%20warm%20peach%20gold%20tones%2C%20simple%20gradient%20background%2C%20elegant%20artistic%20style%2C%20no%20text&width=300&height=400&seq=comic-cover-01-thumb&orientation=portrait',
    chapters: 86,
    tags: ['穿越', '恋爱', '奇幻', '逆袭'],
    featured: true,
    updatedAt: '2026-08-04',
  },
  {
    slug: 'sword-of-thunder',
    title: '雷霆之剑',
    category: 'action',
    author: '朴镇宇',
    status: '连载中',
    rating: 9.5,
    views: 2150000,
    description: '剑术天才韩宇辰在家族惨遭灭门后，独自踏上了复仇之路。他凭借一把祖传的雷霆之剑，在江湖中掀起腥风血雨。然而当他逐渐接近真相时，却发现背后隐藏着更大的阴谋。热血战斗与兄弟情义交织的史诗级武侠巨作。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20action%20martial%20arts%20cover%20art%20featuring%20a%20warrior%20holding%20a%20glowing%20sword%20in%20dramatic%20pose%2C%20dark%20atmospheric%20background%20with%20warm%20amber%20lighting%2C%20epic%20illustration%20style%2C%20dynamic%20composition%2C%20no%20text%20overlay%2C%20high%20quality&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    thumbImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20martial%20arts%20thumbnail%20cover%2C%20warrior%20with%20glowing%20sword%2C%20dramatic%20warm%20amber%20lighting%2C%20simple%20dark%20gradient%20background%2C%20epic%20style%2C%20no%20text&width=300&height=400&seq=comic-cover-02-thumb&orientation=portrait',
    chapters: 124,
    tags: ['武侠', '复仇', '热血', '江湖'],
    featured: true,
    updatedAt: '2026-08-05',
  },
  {
    slug: 'secretarys-secret',
    title: '秘书的秘密',
    category: 'romance',
    author: '李恩珠',
    status: '已完结',
    rating: 8.9,
    views: 980000,
    description: '普通上班族姜素拉被调到了公司最帅但也最冷酷的部长手下做秘书。本以为只是份辛苦的工作，没想到部长竟然有着不为人知的温柔一面。办公室恋情暗潮涌动，甜蜜与心酸交织的都市爱情故事。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20office%20romance%20cover%20art%20featuring%20a%20stylish%20woman%20in%20business%20attire%20with%20soft%20smile%2C%20modern%20office%20setting%20blurred%20background%2C%20warm%20romantic%20lighting%20with%20rose%20pink%20tones%2C%20elegant%20illustration%20style%2C%20no%20text%20overlay&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    thumbImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20office%20romance%20thumbnail%20cover%2C%20stylish%20business%20woman%20portrait%2C%20warm%20rose%20pink%20lighting%2C%20modern%20office%20blur%20background%2C%20elegant%20style%2C%20no%20text&width=300&height=400&seq=comic-cover-03-thumb&orientation=portrait',
    chapters: 64,
    tags: ['职场', '恋爱', '都市', '甜宠'],
    featured: false,
    updatedAt: '2026-07-28',
  },
  {
    slug: 'magic-academy',
    title: '魔法学院',
    category: 'fantasy',
    author: '崔珉豪',
    status: '连载中',
    rating: 9.3,
    views: 1560000,
    description: '在一个魔法与科技并存的世界里，天才少年艾伦进入了最顶尖的星辰魔法学院。在这里他结识了一群志同道合的伙伴，也发现了学院背后隐藏的古老秘密。宏大的世界观与精彩的魔法战斗，带你进入一个全新的奇幻世界。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20fantasy%20magic%20academy%20cover%20art%20featuring%20young%20wizards%20casting%20spells%20in%20a%20grand%20magical%20academy%20hall%2C%20warm%20golden%20magical%20glow%2C%20majestic%20architecture%20background%2C%20enchanting%20illustration%20style%2C%20no%20text%20overlay&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    thumbImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20magic%20academy%20thumbnail%20cover%2C%20young%20wizard%20casting%20spell%2C%20warm%20golden%20magical%20glow%2C%20grand%20academy%20background%2C%20enchanting%20style%2C%20no%20text&width=300&height=400&seq=comic-cover-04-thumb&orientation=portrait',
    chapters: 98,
    tags: ['魔法', '学院', '冒险', '成长'],
    featured: true,
    updatedAt: '2026-08-03',
  },
  {
    slug: 'my-neighbor-is-a-cat',
    title: '邻居是猫妖',
    category: 'comedy',
    author: '郑多情',
    status: '连载中',
    rating: 8.7,
    views: 720000,
    description: '独居青年张小北的隔壁搬来了一位神秘的美女邻居。某天他不小心发现这位邻居竟然是一只修炼千年的猫妖！从此他的生活变得鸡飞狗跳，笑料不断。轻松搞笑的日常治愈系漫画，让你笑到停不下来。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20comedy%20slice%20of%20life%20cover%20art%20featuring%20a%20cute%20girl%20with%20cat%20ears%20in%20casual%20apartment%20setting%2C%20bright%20cheerful%20warm%20lighting%20with%20soft%20yellow%20tones%2C%20fun%20lighthearted%20illustration%20style%2C%20no%20text%20overlay&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    thumbImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20slice%20of%20life%20thumbnail%20cover%2C%20cute%20cat%20ear%20girl%20in%20apartment%2C%20bright%20cheerful%20warm%20lighting%2C%20fun%20style%2C%20no%20text&width=300&height=400&seq=comic-cover-05-thumb&orientation=portrait',
    chapters: 42,
    tags: ['搞笑', '日常', '妖怪', '治愈'],
    featured: false,
    updatedAt: '2026-08-01',
  },
  {
    slug: 'shadow-detective',
    title: '暗影侦探',
    category: 'thriller',
    author: '吴承焕',
    status: '连载中',
    rating: 9.1,
    views: 890000,
    description: '前刑警姜泰浩因一次案件失去了搭档，此后他成为了一名私家侦探。某天他接到一起看似普通的失踪案，却一步步被卷入了一场涉及政商黑幕的巨大阴谋。层层反转的悬疑剧情，扣人心弦的推理过程。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20thriller%20mystery%20cover%20art%20featuring%20a%20detective%20in%20trench%20coat%20standing%20in%20dark%20rainy%20alley%2C%20moody%20atmospheric%20lighting%20with%20deep%20shadows%2C%20noir%20inspired%20illustration%20style%2C%20dramatic%20composition%2C%20no%20text%20overlay&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    thumbImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20mystery%20thumbnail%20cover%2C%20detective%20in%20dark%20rainy%20alley%2C%20moody%20noir%20lighting%2C%20dramatic%20style%2C%20no%20text&width=300&height=400&seq=comic-cover-06-thumb&orientation=portrait',
    chapters: 56,
    tags: ['悬疑', '推理', '犯罪', '都市'],
    featured: false,
    updatedAt: '2026-07-30',
  },
  {
    slug: 'palace-of-flowers',
    title: '花宫物语',
    category: 'historical',
    author: '尹素英',
    status: '已完结',
    rating: 9.4,
    views: 1420000,
    description: '朝鲜时代，一位出身卑微的宫女凭借智慧与美貌在后宫中步步为营。她与年轻君王的虐心之恋，与权臣的暗斗，谱写了一段跌宕起伏的宫廷传奇。精美的古风画风，细腻的情感刻画，不容错过的经典之作。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20historical%20palace%20drama%20cover%20art%20featuring%20a%20beautiful%20woman%20in%20traditional%20Korean%20hanbok%20in%20ancient%20palace%20garden%2C%20elegant%20warm%20lighting%20with%20soft%20golden%20tones%2C%20refined%20artistic%20illustration%20style%2C%20no%20text%20overlay&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    thumbImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20historical%20palace%20drama%20thumbnail%20cover%2C%20woman%20in%20traditional%20hanbok%20in%20palace%20garden%2C%20elegant%20golden%20lighting%2C%20refined%20style%2C%20no%20text&width=300&height=400&seq=comic-cover-07-thumb&orientation=portrait',
    chapters: 72,
    tags: ['古风', '宫廷', '恋爱', '权谋'],
    featured: true,
    updatedAt: '2026-07-15',
  },
  {
    slug: 'cafe-de-paris',
    title: '巴黎咖啡馆',
    category: 'daily',
    author: '韩智敏',
    status: '连载中',
    rating: 8.6,
    views: 520000,
    description: '厌倦了首尔快节奏生活的柳夏恩，只身前往巴黎开了一家小小的咖啡馆。在这里她遇到了形形色色的客人，每个人都有自己的故事。温暖的咖啡香气中，她慢慢治愈了自己的心，也找到了人生真正的方向。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20slice%20of%20life%20cover%20art%20featuring%20a%20woman%20in%20a%20cozy%20Parisian%20cafe%20with%20warm%20ambient%20lighting%2C%20soft%20cream%20and%20brown%20tones%2C%20relaxing%20atmospheric%20illustration%20style%2C%20no%20text%20overlay&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    thumbImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20slice%20of%20life%20thumbnail%20cover%2C%20woman%20in%20cozy%20Parisian%20cafe%2C%20warm%20cream%20brown%20lighting%2C%20relaxing%20style%2C%20no%20text&width=300&height=400&seq=comic-cover-08-thumb&orientation=portrait',
    chapters: 38,
    tags: ['治愈', '日常', '旅行', '美食'],
    featured: false,
    updatedAt: '2026-08-02',
  },
  {
    slug: 'tears-of-a-villainess',
    title: '恶女的眼泪',
    category: 'drama',
    author: '安素妍',
    status: '连载中',
    rating: 9.0,
    views: 1050000,
    description: '被冤枉致死的贵族小姐重生回到了十年前。这一次她决定不再做任人欺凌的弱女子，而是成为人人畏惧的"恶女"。她用冷酷伪装自己，却在复仇的路上遇到了真心对待她的人。虐心又治愈的逆袭故事。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20drama%20revenge%20cover%20art%20featuring%20a%20noblewoman%20with%20cold%20determined%20expression%20in%20luxurious%20gown%2C%20dramatic%20warm%20lighting%20with%20deep%20red%20rose%20accents%2C%20emotional%20illustration%20style%2C%20no%20text%20overlay&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    thumbImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20revenge%20thumbnail%20cover%2C%20noblewoman%20with%20cold%20expression%20in%20gown%2C%20dramatic%20red%20rose%20lighting%2C%20emotional%20style%2C%20no%20text&width=300&height=400&seq=comic-cover-09-thumb&orientation=portrait',
    chapters: 68,
    tags: ['重生', '逆袭', '虐恋', '宫廷'],
    featured: false,
    updatedAt: '2026-08-04',
  },
  {
    slug: 'dragon-warrior',
    title: '龙战士',
    category: 'action',
    author: '姜东元',
    status: '已完结',
    rating: 9.6,
    views: 2680000,
    description: '在一个被巨龙统治的世界里，少年战士金泰勇踏上了屠龙之旅。他与伙伴们穿越雪山、沙漠、深海，挑战七条远古巨龙。震撼的战斗场面，热血澎湃的冒险，让你感受到真正的史诗级故事。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20epic%20fantasy%20cover%20art%20featuring%20a%20heroic%20warrior%20facing%20a%20massive%20dragon%20in%20epic%20battle%2C%20dramatic%20warm%20fire%20and%20amber%20lighting%2C%20cinematic%20illustration%20style%2C%20no%20text%20overlay&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    thumbImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20epic%20fantasy%20thumbnail%20cover%2C%20heroic%20warrior%20facing%20dragon%2C%20dramatic%20amber%20fire%20lighting%2C%20cinematic%20style%2C%20no%20text&width=300&height=400&seq=comic-cover-10-thumb&orientation=portrait',
    chapters: 150,
    tags: ['冒险', '热血', '战斗', '史诗'],
    featured: true,
    updatedAt: '2026-06-20',
  },
  {
    slug: 'love-in-the-stars',
    title: '星际之恋',
    category: 'romance',
    author: '沈银河',
    status: '连载中',
    rating: 8.8,
    views: 760000,
    description: '公元3026年，地球少女艾莉丝在太空站实习时，偶遇了来自外星的王子。跨越星系的浪漫爱情，在浩瀚宇宙中绽放。但两个文明之间的矛盾却让这段感情面临重重考验。科幻与爱情的完美融合。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20sci%20fi%20romance%20cover%20art%20featuring%20a%20couple%20floating%20in%20space%20with%20stars%20and%20nebula%20background%2C%20dreamy%20warm%20purple%20pink%20cosmic%20lighting%2C%20romantic%20sci%20fi%20illustration%20style%2C%20no%20text%20overlay&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    thumbImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20sci%20fi%20romance%20thumbnail%20cover%2C%20couple%20in%20space%20with%20stars%2C%20dreamy%20cosmic%20lighting%2C%20romantic%20style%2C%20no%20text&width=300&height=400&seq=comic-cover-11-thumb&orientation=portrait',
    chapters: 48,
    tags: ['科幻', '恋爱', '星际', '冒险'],
    featured: false,
    updatedAt: '2026-08-01',
  },
  {
    slug: 'ghost-restaurant',
    title: '幽灵餐厅',
    category: 'comedy',
    author: '金美英',
    status: '连载中',
    rating: 8.5,
    views: 610000,
    description: '能看到鬼魂的厨师李泰民开了一家深夜食堂，专门为徘徊在人间的幽灵们烹饪他们生前最怀念的美食。每道菜背后都有一个感人的故事，温暖又治愈。奇幻设定下的美食治愈漫画。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20supernatural%20comedy%20cover%20art%20featuring%20a%20chef%20cooking%20in%20a%20warm%20cozy%20restaurant%20with%20ghostly%20figures%2C%20soft%20warm%20kitchen%20lighting%2C%20heartwarming%20illustration%20style%2C%20no%20text%20overlay&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    thumbImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20supernatural%20comedy%20thumbnail%20cover%2C%20chef%20cooking%20in%20warm%20restaurant%2C%20soft%20kitchen%20lighting%2C%20heartwarming%20style%2C%20no%20text&width=300&height=400&seq=comic-cover-12-thumb&orientation=portrait',
    chapters: 35,
    tags: ['美食', '奇幻', '治愈', '搞笑'],
    featured: false,
    updatedAt: '2026-07-29',
  },
];

export const faqs = [
  {
    question: '布丁漫画上的所有漫画都是免费的吗？',
    answer: '是的！布丁漫画平台上的所有漫画作品均对读者免费开放阅读。我们通过与版权方和作者的合作，以广告和平台补贴的方式维持运营，确保读者能够免费享受正版韩漫内容，同时也保障了创作者的合法权益。',
  },
  {
    question: '布丁漫画的韩漫资源是否为正版？',
    answer: '布丁漫画始终坚持正版路线。我们与韩国多家漫画出版社和创作平台建立了正式合作关系，所有上架作品均获得合法授权。我们致力于为中文读者提供高质量的正版韩漫阅读体验，同时保障作者的版权收益。',
  },
  {
    question: '如何找到我想看的漫画？',
    answer: '您可以通过首页的搜索功能输入漫画名称查找，也可以在分类页面按类型（恋爱、奇幻、动作等）进行筛选浏览。此外，首页的热门推荐和最新更新板块也能帮您发现热门和最新的漫画作品。',
  },
  {
    question: '漫画的更新频率是怎样的？',
    answer: '不同漫画的更新频率不同，一般连载中的作品每周更新一到两话。您可以在漫画详情页查看具体的更新计划。我们建议您收藏喜欢的漫画，这样就能第一时间收到更新通知。',
  },
  {
    question: '布丁漫画有手机App吗？',
    answer: '目前布丁漫画的移动端App正在开发中，预计不久后将上线iOS和Android版本。现阶段您可以通过手机浏览器访问我们的网站，网站已针对移动端进行了优化，提供流畅的移动阅读体验。',
  },
  {
    question: '阅读时遇到问题怎么办？',
    answer: '如果您在阅读过程中遇到任何问题，可以访问我们的"关于我们"页面获取客服联系方式。我们的客服团队将在工作时间内尽快为您解决问题。常见问题也可以查看帮助中心获取解答。',
  },
];

export const aboutInfo = {
  brandName: '布丁漫画',
  founded: '2024年',
  mission: '让每一位中文读者都能免费、便捷地阅读到正版优质的韩国漫画',
  description: '布丁漫画创立于2024年，是国内领先的韩国漫画在线阅读平台。我们与超过50家韩国漫画出版社和创作平台建立了合作关系，拥有超过10000部正版韩漫资源。\n\n我们的团队由资深的漫画爱好者、技术专家和内容运营人员组成，致力于为中国读者打造最优质的韩漫阅读体验。从内容筛选、翻译本地化到阅读器优化，每一个环节我们都精益求精。\n\n我们深知正版对于漫画行业的重要性。通过合法授权和合规运营，我们确保每一位创作者都能获得应有的回报，每一位读者都能安心阅读。',
  stats: [
    { label: '正版漫画', value: '10,000+' },
    { label: '合作出版社', value: '50+' },
    { label: '日活跃用户', value: '200万+' },
    { label: '累计阅读量', value: '50亿+' },
  ],
  contact: {
    email: 'contact@puddingcomic.com',
    phone: '400-888-6666',
    address: '北京市朝阳区望京SOHO T3 12层',
    wechat: '布丁漫画官方',
    weibo: '@布丁漫画',
  },
};